// NV — ensure high-res images for the mobile horizontal product gallery
document.addEventListener('DOMContentLoaded', () => {
  const scrollerSelectors = [
    '.product__media-list',
    '.product-media',
    '.product-gallery',
    '.product-gallery__media-list',
    '.pd-gallery',
    '.media-gallery',
    '.main-product .gallery',
    '.main-product .product__media'
  ].join(',');

  const slideSelectors = [
    '.product__media-item',
    '.product-media__item',
    '.product-gallery__image',
    '.pd-gallery__item',
    '.media-gallery__item',
    '.main-product .gallery__item'
  ].join(',');

  const scrollers = document.querySelectorAll(scrollerSelectors);
  if (!scrollers.length) return;

  scrollers.forEach(scroller => {
    // 1) Make the first 2 images eager so the first swipe looks crisp
    const firstImgs = scroller.querySelectorAll(`${slideSelectors} img`);
    firstImgs.forEach((img, i) => {
      if (i < 2) {
        try {
          img.loading = 'eager';
          img.fetchPriority = 'high';
          img.decoding = 'sync';
          img.sizes = '100vw';
          if (img.dataset && img.dataset.srcset && !img.srcset) {
            img.srcset = img.dataset.srcset; // some themes store real srcset in data-srcset
          }
        } catch (e) {}
      }
    });

    // 2) Observe slides inside the horizontal scroller (root = scroller)
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const slide = entry.target;

        // Prefer the media element inside the slide; otherwise the slide itself
        const media = slide.querySelector('img, video, model-viewer') || slide;

        // Images: ask for high quality immediately
        if (media && media.tagName === 'IMG') {
          try {
            media.loading = 'eager';
            media.fetchPriority = 'high';
            media.decoding = 'sync';
            media.sizes = '100vw';

            // If theme uses lazy data-* attributes, promote them now
            if (media.dataset) {
              if (media.dataset.srcset && (!media.srcset || media.srcset.length < 10)) {
                media.srcset = media.dataset.srcset;
              }
              if (media.dataset.src && (!media.src || media.src.indexOf('placeholder') !== -1)) {
                media.src = media.dataset.src;
              }
            }
          } catch (e) {}
        }

        // Videos: at least ensure metadata/first frame is ready
        if (media && media.tagName === 'VIDEO') {
          media.preload = media.preload || 'metadata';
        }
      });
    }, { root: scroller, threshold: 0.6 });

    scroller.querySelectorAll(slideSelectors).forEach(slide => io.observe(slide));
  });
});
